// src/directives/vFadeOut.js

const startFadeTimeout = (el, binding) => {
    // 1. Vyčistíme předchozí timeout, pokud existuje (důležité pro opakované odeslání)
    if (el._fadeTimeout) clearTimeout(el._fadeTimeout);

    // Výchozí čas 5s (5000ms), pokud v šabloně nezadáš jiný
    const duration = binding.value || 1500;

    // 2. Okamžitý reset stylů na viditelný stav bez animace
    el.style.transition = 'none';
    el.style.opacity = '1';

    // Vynucení překreslení (reflow), aby prohlížeč zaregistroval 'none' před aplikací animace
    el.offsetHeight;

    // 3. Nastavení plynulého přechodu (zmizení potrvá 2 sekundy)
    el.style.transition = 'opacity 2000ms ease';
    //el.style.transition = 'opacity 8000ms ease';
    // 4. Spuštění odpočtu, po kterém se změní opacita na 0
    el._fadeTimeout = setTimeout(() => {
        el.style.opacity = '0';
        //el.style.backgroundColor = 'lime';
    }, duration);

    //el.style.color = 'red';
    //el.style.backgroundColor = 'yellow';
};

export default {
    mounted(el, binding) {
        //console.log("dev fadeOutElement mounted")
        startFadeTimeout(el, binding);
    },
    updated(el, binding) {
        console.log("dev fadeOutElement updated")
        startFadeTimeout(el, binding);
    },
    unmounted(el) {
        // Prevence memory leaků - vyčištění při smazání z DOMu
        if (el._fadeTimeout) clearTimeout(el._fadeTimeout);
    }
};